<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="loading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary tw-text-center">
                Members List Export
            </h2>
            <div class="pb-0">
                <div class="tw-flex tw-mb-2 tw-p-2">
                    <v-select
                        v-model="exportTypeSelected"
                        :items="exportTypesList"
                        dense
                        color="primary"
                        label="Export Type"
                        display-label="Export Type"
                        hide-details
                        reactive
                        outlined
                        class="mb-5"
                    />
                </div>
            </div>

            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3">

                <v-btn
                    text
                    @click="cancelDialog"
                    class="btn-solid"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="requestExportExecution"
                    class="main-btn"
                    :loading="loading"
                >
                    Export
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name: "ExportMembersModal",
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            type: Boolean,
            required: true
        },
        'filters': {
            // The filters that will be used as a starting point for the export
            type: Object,
            required: false
        },
        'constants': {
            // The constants we will rely on
            type: Object,
            required: false
        },
        'valuelists': {
            // The constants we will rely on
            type: Object,
            required: false
        },
        'export_filename': {
            // This determines the name of the file that gets exported
            type: String,
            required: false,
            default: function () {
                return 'members-export.xlsx'
            }
        },
    },
    data() {
        return {
            dialog: this.value || false,
            loading: false,
            filter: this.filters,
            exportTypesList: [
                {text: 'Email/Phone', value: 'emailPhone'},
                {text: 'Detailed', value: 'detailed'},
            ],
            exportTypeSelected: 'emailPhone',
            exportFilename: this.export_filename,
        }
    },
    mounted() {
        //
    },
    computed: {
        dialog_width() {
            return '450px'
        },
    },
    methods: {
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        async requestExportExecution() {
            axios({
                url: route('members.export'),
                method: 'post',
                data: this.$data,
                onUploadProgress: (evt) => {
                    this.loading = !this.loading
                },
                onDownloadProgress: (evt) => {
                    this.loading = !this.loading
                },
            })
                .then(response => {
                    if (response.data.success) {
                        this.$root.snackbar.success(`You will receive an email to ${this.$page.user?.email} with the export once it is done.`)
                        this.loading = false
                        this.dialog = false
                    } else {
                        throw (response.data.error)
                    }
                })
                .catch((error) => {
                    this.$root.snackbar.error(error.response.data.message)
                    this.loading = false
                })
            this.loading = false
        },
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
            } else {
                // Opening modal
            }
        },
        filters(newFilters, oldFilters) {
            this.filter = newFilters
        },
        exportTypeSelected(newTypeSelected, oldTypeSelected) {
            if (newTypeSelected === 'emailPhone'){
                this.exportFilename = 'members-export.xlsx'
            } else if (newTypeSelected === 'detailed'){
                this.exportFilename = 'detailed-members-export.xlsx'
            }
        }
    },
}

</script>

<style scoped>

</style>
